module.exports = __webpack_public_path__ + "static/media/Health.0c81a701.svg";